export default __webpack_public_path__ + "ecd24623730a9eced4d163fb452e4c7b.png";